import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from './feedbackFormat';

/** 官方回覆區塊（留言、許願共用）：品牌淡底，與使用者內容區隔 */
const OfficialReply: React.FC<{ reply: string; repliedAt: string | null }> = ({ reply, repliedAt }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-3 rounded-md bg-accent-soft px-4 py-3">
      <div className="mb-1 flex items-center justify-between gap-2">
        <span className="text-[13px] font-semibold text-accent">{t('pages.feedback.official_reply')}</span>
        {repliedAt && <span className="text-[13px] text-fg-secondary whitespace-nowrap">{formatDateTime(repliedAt)}</span>}
      </div>
      <p className="text-sm text-fg whitespace-pre-wrap leading-relaxed">{reply}</p>
    </div>
  );
};

export default OfficialReply;
